const sections = {
  section: document.getElementById('jsTopData') as HTMLElement | null,
  dataLink: document.getElementById('jsDataLink') as HTMLElement | null,
  badges: document.querySelectorAll(
    '.product-data__single-badge',
  ) as NodeListOf<HTMLElement>,
  init() {
    this.checkSection();
  },

  checkSection() {
    window.addEventListener('DOMContentLoaded', () => {
          if (this.section) {
      if (this.section.children.length > 0) {
        this.section.classList.remove('activeClass');
      } else {
        this.section.classList.add('activeClass');

        if (this.badges.length < 1) {
          
              if (this.dataLink) {
              this.dataLink.classList.add('d-none');
              }

              if(this.section) {
                this.section.parentElement?.parentElement?.classList.add('is-removed');
              }
        }
      }
    }
    })
  },
};

export default sections;
